import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import { default as orgDataService } from 'app/services/data/org.data.service';
import addEditFolderDialog from './dialog.addEditFolderDialog';
import addEditDocumentDialog from './dialog.addEditDocumentDialog';
import uploadDocumentDialog from './dialog.uploadDocumentDialog';
import documentAssociationDialog from './dialog.documentAssociationDialog';
import folder from './folder';
import controller from './document-management-dialog.controller';
import template from './document-management-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
} = library;

require('angular-recursion');

const RecursionHelper = 'RecursionHelper';


export class dialogService {
  getOptions($event, {
    serviceId = null,
    parentFolderId = -1,
    dialogTitle = 'Document Management',
    canAddFolder = false,
    canDeleteFolder = false,
    canAddDocument = false,
    canDeleteDocument = false,
    canAttach = false,
    attachCallback,
    maxAttachments = 0,
    attachedIds = [],
    attachmentTypeId = 0,
    attachmentEntityId = 0,
    folderList,
    customerServices,
    onCloseCallBack = () => {},
  }) {
    return {
      controller,
      controllerAs: 'documentManagementDialogVM',
      locals: {
        serviceId,
        parentFolderId,
        dialogTitle,
        canAddFolder,
        canDeleteFolder,
        canAddDocument,
        canDeleteDocument,
        canAttach,
        attachCallback,
        maxAttachments,
        attachedIds,
        attachmentTypeId,
        attachmentEntityId,
        folderList,
        customerServices,
        onCloseCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.documentManagement.documentManagementDialog', [
  RecursionHelper,
  addEditFolderDialog,
  addEditDocumentDialog,
  alerts,
  confirmDialog,
  docDataService,
  folder,
  loaderService,
  orgDataService,
  ssDialogService,
  uploadDocumentDialog,
  documentAssociationDialog,
])
  .service('documentManagementDialog', dialogService)
  .controller('DocumentManagementDialogController', controller)
  .name;

console.log('app.components.global.documentManagement.documentManagementDialog created');
